module.exports = __webpack_public_path__ + "h5/img/cartLack.2266ad38.png";